import React from "react";
import { useIds } from "../../../hook/AdminContext";
import { Tooltip } from "@mui/material";
import {
  address_icon,
  cap_icon,
  email_icon,
  phone_icon,
  website_icon,
} from "../../../assets";
import AboutDescription from "./profile-sections/AboutDescription";

const About = ({ data }) => {
  const { userInfo } = useIds();
  const isCandidate = userInfo?.role === "candidate";

  // Sector badge component
  const SectorBadge = ({ sector, clientType }) => (
    <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded-full tw-bg-gray-100 tw-text-gray-700 tw-text-sm">
      {sector?.title && <span className="tw-font-medium">{sector.title}</span>}
      {sector?.title && clientType && (
        <span className="tw-text-gray-400">•</span>
      )}
      {clientType && <span>{clientType}</span>}
    </span>
  );

  return (
    <div className="card-1 p-3 mb-3 mt-3">
      {/* Basic Information Section */}
      {(data?.about || data?.description || data?.leader_description) && (
        <>
          <div className="section-heading mb-3">Overview</div>
          <AboutDescription
            data={
              data?.about || data?.description || data?.leader_description || ""
            }
          />
        </>
      )}
      <div className="section-heading my-3">Basic Information</div>

      {data?.company_name && (
        <div className="mb-3">
          <img src={cap_icon} alt="company_icon" />
          <Tooltip title="Company Name" arrow>
            <span className="ps-2">{data.company_name}</span>
          </Tooltip>
        </div>
      )}

      {/* {data?.contact_name && (
        <div className="mb-3">
          <img src={cap_icon} alt="contact_icon" />
          <Tooltip title="Contact Name" arrow>
            <span className="ps-2">{data.contact_name}</span>
          </Tooltip>
        </div>
      )} */}

      {data?.location && (
        <div className="mb-3">
          <img src={address_icon} alt="location_icon" />
          <Tooltip title="Location" arrow>
            <span className="ps-2">{data.location}</span>
          </Tooltip>
        </div>
      )}

      {data?.website_url && (
        <div className="mb-3">
          <img src={website_icon} alt="website_icon" />
          <Tooltip title="Website URL" arrow>
            <a
              href={data.website_url}
              target="_blank"
              rel="noopener noreferrer"
              className="ps-2"
            >
              {data.website_url}
            </a>
          </Tooltip>
        </div>
      )}

      {data?.contact_number && (
        <div className="mb-3">
          <img src={phone_icon} alt="phone_icon" />
          <Tooltip title="Phone Number" arrow>
            <span className="ps-2">{data.contact_number}</span>
          </Tooltip>
        </div>
      )}

      {/* Direct Contact Information - Hidden for Candidates */}
      {!isCandidate &&
        data?.direct_contact_enabled &&
        data?.direct_contact?.full_name && (
          <>
            <div className="section-heading mt-4 mb-3">
              Direct Contact Information
            </div>

            {data.direct_contact.full_name && (
              <div className="mb-3">
                <img src={cap_icon} alt="name_icon" />
                <Tooltip title="Full Name" arrow>
                  <span className="ps-2">{data.direct_contact.full_name}</span>
                </Tooltip>
              </div>
            )}

            {data.direct_contact.email_address && (
              <div className="mb-3">
                <img src={email_icon} alt="email_icon" />
                <Tooltip title="Email" arrow>
                  <span className="ps-2">
                    {data.direct_contact.email_address}
                  </span>
                </Tooltip>
              </div>
            )}

            {data.direct_contact.company_email && (
              <div className="mb-3">
                <img src={email_icon} alt="company_email_icon" />
                <Tooltip title="Company Email" arrow>
                  <span className="ps-2">
                    {data.direct_contact.company_email}
                  </span>
                </Tooltip>
              </div>
            )}

            {data.direct_contact.phone_number && (
              <div className="mb-3">
                <img src={phone_icon} alt="phone_icon" />
                <Tooltip title="Phone Number" arrow>
                  <span className="ps-2">
                    {data.direct_contact.phone_number}
                  </span>
                </Tooltip>
              </div>
            )}

            {data.direct_contact.job_title && (
              <div className="mb-3">
                <img src={cap_icon} alt="job_title_icon" />
                <Tooltip title="Job Title" arrow>
                  <span className="ps-2">{data.direct_contact.job_title}</span>
                </Tooltip>
              </div>
            )}
          </>
        )}

      {/* Sectors with Client Types */}
      {data?.client_type && data.client_type.length > 0 && (
        <div className="mt-3 mb-3">
          <div className="section-heading mb-2">Sector</div>
          <div className="tw-flex tw-flex-wrap tw-gap-2">
            {data.client_type
              .filter((item) => item.sector?.title)
              .map((item, index) => (
                <SectorBadge
                  key={index}
                  sector={item.sector}
                  clientType={item.title}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default About;
